// Which day group a conversation falls in, as ChatGPT and Claude show them:
// today, yesterday, the last seven days, and earlier.
//
// By calendar day in the person's own clock, not by 24-hour slices: something
// from 23:50 yesterday is «yesterday» at 00:10 today.

export type DayGroup = 'today' | 'yesterday' | 'week' | 'earlier'

export const DAY_GROUPS: DayGroup[] = ['today', 'yesterday', 'week', 'earlier']

function startOfDay(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
}

export function dayGroupOf(when: string | Date, now: Date = new Date()): DayGroup {
  const days = Math.round((startOfDay(now) - startOfDay(new Date(when))) / 86_400_000)
  if (days <= 0) return 'today'
  if (days === 1) return 'yesterday'
  if (days < 7) return 'week'
  return 'earlier'
}

/** The items split by group, in the order given, leaving out empty groups. */
export function byDayGroup<T>(items: T[], whenOf: (item: T) => string, now: Date = new Date()) {
  const groups = new Map<DayGroup, T[]>()
  for (const item of items) {
    const group = dayGroupOf(whenOf(item), now)
    groups.set(group, [...(groups.get(group) ?? []), item])
  }
  return DAY_GROUPS.filter((group) => groups.has(group)).map((group) => ({ group, items: groups.get(group)! }))
}
